@if (items.length > 0) {
  <ng-select
    [items]="items"
    bindLabel="displayLabel"
    bindValue="certificateKey"
    [multiple]="true"
    [searchable]="true"
    [clearable]="true"
    [closeOnSelect]="false"
    [formControl]="fc"
    [class.ng-select-sm]="size === 'sm'"
    placeholder="พิมพ์เพื่อค้นหาและเลือกใบรับรอง"
    notFoundText="ไม่พบใบรับรองที่ค้นหา"
    typeToSearchText="พิมพ์เพื่อค้นหาใบรับรอง"
    [class.is-invalid]="isInvalid">

    <ng-template ng-clearbutton-tmp>
      <i class="bi bi-x-lg"></i>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items; track item) {
        <div class="cert-chip"
             [class.cert-chip--legacy]="isLegacy(item)"
             [class.cert-chip--self]="isSelfCreated(item)"
             [title]="siteText(item)">
          <span class="cert-chip__label">
            @if (item.certificateNo) {
              <span class="cert-chip__code">{{ item.certificateNo }}</span>
            }
            @if (item.standardCode) {
              <strong class="cert-chip__code">{{ item.standardCode }}</strong>
              @if (item.standardName) {
                <span class="cert-chip__name"> {{ item.standardName }}</span>
              }
            } @else {
              <span class="cert-chip__name">{{ item.standardName || item.title || item.displayLabel }}</span>
            }
            @if (siteShort(item); as where) {
              <!-- Two certificates of one standard can cover different sites (work item 177): say which. -->
              <span class="cert-chip__site"><i class="bi bi-geo-alt-fill" aria-hidden="true"></i>{{ where }}</span>
            }
          </span>
          <button type="button" class="cert-chip__remove" (click)="clear(item)" aria-label="ลบใบรับรอง" title="ลบ">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
      }
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-item$="item$">
      <div class="d-flex align-items-start justify-content-between w-100 py-1 cert-option">
        <div class="d-flex flex-column text-start min-w-0">
          <div class="d-flex align-items-baseline gap-2 flex-wrap">
            @if (item.certificateNo) {
              <span class="text-dark standard-title">{{ item.certificateNo }}</span>
            }
            @if (item.standardCode) {
              <span class="text-secondary fw-semibold">{{ item.standardCode }}</span>
            }
            <span class="text-dark standard-title">{{ item.standardName || item.title || item.displayLabel }}</span>
          </div>
          <!-- The production site on its own line (work item 177), wrapping when long, so
               certificates of the same standard for different places can be told apart. -->
          @if (siteText(item); as where) {
            <div class="cert-option__site">
              <i class="bi bi-geo-alt-fill" aria-hidden="true"></i>
              <span>{{ where }}</span>
            </div>
          }
        </div>
        @if (item$.selected || isSelected(item)) {
          <i class="bi bi-check2 text-primary ms-2 flex-shrink-0"></i>
        }
      </div>
    </ng-template>
  </ng-select>
  <div class="cert-count">เลือกแล้ว {{ selectedCount }} ใบรับรอง</div>
} @else {
  <div class="cert-empty">
    <div class="cert-empty__title">ยังไม่มีใบรับรองให้เลือก</div>
    <div class="cert-empty__hint">กรุณาเพิ่มใบรับรองในระบบก่อนเลือกธุรกิจ</div>
  </div>
}
